module.exports = __webpack_public_path__ + "static/desktop/img/template-travel-2.26c77b05.png";